import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { mediaCSS, textSizes } from 'theme/media'
import { IStyles } from '../../../theme'

const deviceSettingsLogLevelStyles: IStyles = {
    title: {
        fontSize: textSizes.normal,
        ...grid.mb_md,
    },
    dropdownWrapper: {
        ...grid.w25,
        [mediaCSS.tab]: {
            ...grid.w50,
        },
        [mediaCSS.tabMini]: {
            ...grid.w100,
        },
    },
    checkboxWrapper: {
        marginBottom: 20,
    },
    label: {
        fontSize: 14,
    },
}

addStyles(deviceSettingsLogLevelStyles)
export default deviceSettingsLogLevelStyles
